import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IconType, IoniconsOutline} from '@pt/pt-models';

@Component({
  selector: 'pt-delete-with-confirm',
  template: `
    <button class='btn btn-sm btn-danger d-flex align-items-end'
            [disabled]="disabled"
            *ngIf='!showConfirm' (click)='showConfirm = true'>
      <pt-icon
        [size]='15'
        *ngIf='showIcon'
        [key]='IconDeleteComment'
      ></pt-icon>
      {{ "BUTTON.DELETE" | translate }}
    </button>

    <div class='bg-confirm-delete' *ngIf='showConfirm'>
      <label class='m-0 me-2'>{{ confirmMessage }}</label>

      <pt-button-with-loader
        [disabled]="disabled"
        [label]='"BUTTON.CONFIRM" | translate'
        [loading]='loading'
        (buttonWithLoaderClick)='clickConfirmDelete.emit()'
      ></pt-button-with-loader>

      <button class='btn btn-sm btn-outline-secondary ms-1 text-white'
              (click)='showConfirm = false'>
        {{ "BUTTON.CANCEL" | translate }}
      </button>
    </div>
  `,
  styles: [
    `
      .btn-delete {
        margin: 10px;
      }

      .bg-confirm-delete {
        display: flex;
        background: #333333ee;
        color: white;
        width: 100%;
        height: 100%;
        padding: 2px 5px;
        align-items: center;
        justify-content: center;
      }
    `
  ]
})
export class DeleteWithConfirmComponent {

  @Input() showIcon = true;
  @Input() confirmMessage: string;
  @Input() loading = false;
  @Input() disabled = false;

  @Output() clickConfirmDelete = new EventEmitter;

  public IconType = IconType;
  public IconDeleteComment = IoniconsOutline.trash;

  public showConfirm = false;

}
